import React, {useEffect, useLayoutEffect, useRef} from 'react';
import {SwitchThemeButton} from '../theme-switch/switch-theme-button';
import {useIdMirrorTheme} from '../../hooks/use-id-mirror-theme';
import {DarkIdPolo, LightIdPolo} from '../../data/id-mirror-data';
import gsap from 'gsap';
import {Column, Img, MirroredImageWrapper} from './ui/mirrored-image-styles';

export const MirroredImageContainer: React.FC = () => {
  const columnRef = useRef<HTMLDivElement | null>(null);
  const topRef = useRef<HTMLImageElement | null>(null);
  const bottomRef = useRef<HTMLImageElement | null>(null);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const {isReversed, registerRefs} = useIdMirrorTheme();

  // set initial state on mount
  useLayoutEffect(() => {
    gsap.set(columnRef.current, {rotate: isReversed ? 180 : 0});
    gsap.set(topRef.current, {
      opacity: isReversed ? 0.4 : 1,
      scale: isReversed ? 0.6 : 1,
      y: isReversed ? 40 : 0,
    });
    gsap.set(bottomRef.current, {
      rotate: 180,
      opacity: isReversed ? 1 : 0.4,
      scale: isReversed ? 1 : 0.6,
      y: isReversed ? 0 : -40,
    });
  }, []);

  // register refs solo cuando el componente es visible (Desktop)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          registerRefs({
            columnRef: columnRef.current,
            topImg: topRef.current,
            bottomImg: bottomRef.current,
            // clear mobile refs
            sliderDarkImg: null,
            sliderLightImg: null,
          });
        } else {
          registerRefs({
            columnRef: null,
            topImg: null,
            bottomImg: null,
          }); // cuando el componente se desmonta -> limpiar refs
        }
      },
      {threshold: 0.1},
    );

    if (wrapperRef.current) observer.observe(wrapperRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <MirroredImageWrapper ref={wrapperRef} className="mirrored-image-wrapper">
      <Column ref={columnRef} className="mirrored-image-column">
        <Img
          ref={topRef}
          src={DarkIdPolo}
          alt="top"
          className="mirrored-image-top"
        />
        <div style={{height: '66px'}} />
        <Img
          ref={bottomRef}
          src={LightIdPolo}
          alt="bottom"
          className="mirrored-image-bottom"
        />
      </Column>

      <div
        style={{
          position: 'absolute',
          zIndex: 0,
          pointerEvents: 'auto',
        }}
        className="switch-theme-button-container"
      >
        <SwitchThemeButton />
      </div>
    </MirroredImageWrapper>
  );
};
